module.exports = __webpack_public_path__ + "img/cropperGuide.4de48982.png";